// extracted by mini-css-extract-plugin
module.exports = {"link":"KlbrLink_link__fN1eg"};